class AbProductGallery extends HTMLElement {
  constructor() {
    super();
    this.mainSlider = null;
    this.thumbnailSlider = null;
    this.mainSliderElement = this.querySelector(".ab-product-media-main.splide");
    this.thumbnailSliderElement = this.querySelector(".ab-product-media-thumbnails.splide");
  }

  connectedCallback() {
    this.initSliders();
    document.addEventListener("variant:changed", this.updateMedia.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.updateMedia.bind(this));
  }

  initSliders() {
    const showGalleryArrow = this.dataset.galleryArrow === "true";
    const showThumbnailArrow = this.dataset.thumbnailArrow === "true";
    const initialSlide = parseInt(this.dataset.initialSlide) || 0;

    if (this.mainSliderElement) {
      this.mainSlider = new Splide(this.mainSliderElement, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: showGalleryArrow,
        keyboard: true,
        start: initialSlide
      });
      this.mainSlider.mount();
    }

    if (this.thumbnailSliderElement) {
      this.thumbnailSlider = new Splide(this.thumbnailSliderElement, {
        direction: 'ttb',
        height: "100%",
        fixedWidth: 90,
        perPage: 5,
        pagination: false,
        isNavigation: true,
        arrows: showThumbnailArrow,
        start: initialSlide,
        breakpoints: {
          1000: { 
            direction: 'ltr',
            height: 'auto',
            fixedWidth: null,
          },
          800: {
            perPage: 5,
          },
          480: { 
            fixedWidth: null,
            perPage: 4 
          }
        }
      });

      
      this.thumbnailSlider.on('visible', (slide) => {
        const buttons = slide.slide.querySelectorAll('button');
        buttons.forEach(button => {
          button.removeAttribute('tabindex');
          button.removeAttribute('aria-hidden');
        });
      });

      this.thumbnailSlider.on('hidden', (slide) => {
        const buttons = slide.slide.querySelectorAll('button');
        buttons.forEach(button => {
          button.setAttribute('tabindex', '-1');
          button.setAttribute('aria-hidden', 'true');
        });
      });
      
      this.thumbnailSlider.mount();
    }

    if (this.mainSlider && this.thumbnailSlider) {
      this.mainSlider.sync(this.thumbnailSlider);
    }
  }

  updateMedia(event) {
    const variant = event.detail.variant;
    
    if (!variant || !variant.featured_media) return;

    const mediaIndex = Array.from(this.querySelectorAll(".splide__slide[data-media-id]")).findIndex(
      (media) => parseInt(media.dataset.mediaId) === variant.featured_media.id
    );

    if (mediaIndex !== -1 && this.mainSlider) {
      this.mainSlider.go(mediaIndex);
    }
  }
}
customElements.define("ab-product-gallery", AbProductGallery);

class AbProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener("variant:changed", this.handleVariantChange.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.handleVariantChange.bind(this));
  }

  handleVariantChange(event) {
    const { variant, productData } = event.detail || {};
    if (!variant || !productData) {
      console.error("Invalid variant:changed event data:", event.detail);
      return;
    }
    this.updateURL(productData.productURL, variant);
    this.updateSections(variant);
  }

  updateURL(url, variant) {
    window.history.replaceState({}, "", `${url}${variant ? `?variant=${variant.id}` : ""}`);
  }

  updateSections(variant) {
    const sectionId = this.dataset.sectionId || 'ab-product-main';
    const url = `${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;
    
    const priceElement = this.querySelector('.ab-product-price');
    const buttonElement = this.querySelector('.product-atc__button');
    if (priceElement) priceElement.classList.add('loading');
    if (buttonElement) buttonElement.classList.add('loading');

    fetch(url)
      .then(response => {
        return response.text();
      })
      .then(data => {
         const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data;

        this.innerHTML = tempDiv.querySelector('.ab-product-info').innerHTML;

      })
      .catch(error => console.error("Error fetching section:", error))
      .finally(() => {
        if (priceElement) priceElement.classList.remove('loading');
        if (buttonElement) buttonElement.classList.remove('loading');
      });
  }
}
customElements.define("ab-product-info", AbProductInfo);

class AbReadMore extends HTMLElement {
  constructor() {
    super()
    this.maxHeight = Number.parseInt(this.dataset.maxHeight) || 150
    this.content = this.querySelector(".ab-read-more__content")
    this.button = null
  }

  connectedCallback() {
    if (this.content.scrollHeight > this.maxHeight) {
      this.content.style.maxHeight = `${this.maxHeight}px`
      this.content.classList.add("collapsed")

      this.insertAdjacentHTML(
        "beforeend",
        `
        <button class="ab-read-more__button">Read More</button>
      `,
      )

      this.button = this.querySelector(".ab-read-more__button")
      this.button.addEventListener("click", () => this.toggle())
    }
  }

  toggle() {
    const isCollapsed = this.content.classList.contains("collapsed")

    if (isCollapsed) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`
      this.content.classList.remove("collapsed")
      this.button.textContent = "Read Less"
    } else {
      this.content.style.maxHeight = `${this.maxHeight}px`
      this.content.classList.add("collapsed")
      this.button.textContent = "Read More"
    }
  }
}
customElements.define("ab-read-more", AbReadMore)


class AbVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.productForm = document.querySelector('[action="/cart/add"]');
    this.variantInput = this.productForm.querySelector('[name="id"]');
    this.productData = document.querySelector("[data-product-json]")?.textContent 
      ? JSON.parse(document.querySelector("[data-product-json]").textContent) : null;
    this.variants = JSON.parse(this.querySelector('script').textContent);
  }

  connectedCallback() {
   
    this.addEventListener("click", this.handleSwatchClick.bind(this));
  }

  handleSwatchClick(event) {
    if (!event.target.matches('.swatch__button')) return;
    
    const swatch = event.target.closest('.swatch');
    const group = swatch.closest('.ab-product-varaint__group');
    const input = group.querySelector('input');

    group.querySelectorAll('.swatch').forEach(s => s.removeAttribute('selected'));
    swatch.setAttribute('selected', '');
    
    input.value = event.target.value;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    this.updateVariant();
  }

  updateVariant() {
    const selectedOptions = Array.from(
      this.querySelectorAll('input[data-type="variant-input"]'),
      input => input.value
    );

    const currentVariant = this.variants.find(variant =>
      variant.options.every((option, i) => selectedOptions[i] === option)
    );
    this.variantInput.value = currentVariant?.id || '';
    
    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { variant: currentVariant, productData: this.productData }
    }));
    
  }

}

customElements.define("ab-variant-picker", AbVariantPicker);

class AbQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('#quantity-minus');
    this.plusBtn = this.querySelector('#quantity-plus');
    this.input = this.querySelector('input');
    this.formInput = document.querySelector(`#${this.dataset.form} input[name="quantity"]`);
  }

  connectedCallback() {
    this.minusBtn.addEventListener('click', () => this.updateQuantity(-1));
    this.plusBtn.addEventListener('click', () => this.updateQuantity(1));
    this.input.addEventListener('change', () => this.syncToForm());
    this.updateButtonStates(); 
  }

  updateQuantity(change) {
    const newValue = Math.max(1, parseInt(this.input.value) + change);
    const max = parseInt(this.input.max) || Infinity;
    this.input.value = Math.min(newValue, max);
    this.syncToForm();
    this.updateButtonStates();
    document.dispatchEvent(
      new CustomEvent('quantityChanged', {
        detail : { quantity : parseInt( this.input.value )}
      })
    )
  }

  syncToForm() {
    this.formInput.value = this.input.value;
    this.updateButtonStates();
    document.dispatchEvent(
      new CustomEvent('quantityChanged', {
        detail : { quantity : parseInt( this.input.value )}
      })
    )
  }

  updateButtonStates() {
    const value = parseInt(this.input.value);
    const min = parseInt(this.input.min) || 1;
    const max = parseInt(this.input.max) || Infinity;
    
    this.minusBtn.disabled = value <= min;
    this.plusBtn.disabled = value >= max;
  }
}
customElements.define('ab-quantity-selector', AbQuantitySelector);

class AbProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('[action="/cart/add"]');
  }

  connectedCallback() {
    document.addEventListener("click", this.handleAddToCart.bind(this));
    this.form?.addEventListener("submit", this.handleAddToCart.bind(this));
    document.addEventListener("input", this.handleInputChange.bind(this));
  }

  handleAddToCart(event) {
    const button = event.target.closest('.ab-global-atc__btn');
    if (!button && event.type !== 'submit') return;
    
    event.preventDefault();
    
    const btn = button || document.querySelector('.ab-global-atc__btn');
    if (!btn || btn.disabled) return;

    // Validate required inputs
    if (!this.validateInputs()) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    const mainVariantId = this.form.querySelector('[name="id"]').value;
    const mainQuantity = this.form.querySelector('[name="quantity"]')?.value || '1';
    
    const items = [{ 
      id: Number(mainVariantId), 
      quantity: Number(mainQuantity),
      properties: this.getProperties() 
    }];
  
    // if (window.AddonState.addons.size === 0){
    //   alert("Please select at least one addon before adding to cart.");
    //   btn.textContent = originalText;
    //   btn.disabled = false;
    //   return;
    // }

    if (window.AddonState?.addons) {
      const addonProperties = this.getAddonProperties();
      
      window.AddonState.addons.forEach((qty, variantId) => {
        const item = { 
          id: Number(variantId), 
          quantity: Number(qty) 
        };
        
        const variantKey = variantId.toString();
        if (addonProperties[variantKey]) {
         item.properties = {
            [addonProperties[variantKey].productTitle]: addonProperties[variantKey].text
          };
        }
        
        items.push(item);
      });
    }
    

    fetch("/cart/add.js", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(response => response.json())
    .then(() => window.location.href = "/cart")
    .catch(error => {
      console.error("Add to cart failed:", error);
      btn.textContent = originalText;
      btn.disabled = false;
    });
  }

  handleInputChange(event) {
    if (event.target.matches('.js-properties-input, .js-main-properties-input')) {
      const input = event.target;
      const errorSpan = input.parentNode.querySelector('.input-error');
      
      if (input.value.trim()) {
        input.classList.remove('error');
        if (errorSpan) errorSpan.style.display = 'none';
      }
    }
  }

  validateInputs() {
    const requiredTextInputs = document.querySelectorAll('.ab-addons-properties.is-show[data-property-type="text"] .js-properties-input, .js-main-properties-input');
    const requiredImageUploads = document.querySelectorAll('.ab-addons-properties.is-show[data-property-type="image"]');
    
    // Clear previous errors
    document.querySelectorAll('.js-properties-input, .js-main-properties-input').forEach(input => {
      input.classList.remove('error');
      const errorSpan = input.nextElementSibling;
      if (errorSpan && errorSpan.classList.contains('input-error')) {
        errorSpan.style.display = 'none';
      }
    });
    
    // Clear image upload errors
    document.querySelectorAll('.ab-addons-image-upload-wrapper .input-error').forEach(error => {
      error.style.display = 'none';
    });
    
    let isValid = true;
    let firstError = null;
    
    // Validate text inputs
    requiredTextInputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false;
        input.classList.add('error');
        const errorSpan = input.nextElementSibling;
        if (errorSpan && errorSpan.classList.contains('input-error')) {
          errorSpan.style.display = 'block';
        }
        if (!firstError) firstError = input;
      }
    });
    
    // Validate image uploads
    requiredImageUploads.forEach(section => {
      const variantId = Number.parseInt(section.dataset.variantId);
      const hasImage = window.AddonState.properties.has(variantId);
      
      if (!hasImage) {
        isValid = false;
        const errorSpan = section.querySelector('.ab-addons-image-upload-wrapper .input-error');
        if (errorSpan) {
          errorSpan.style.display = 'block';
        }
        if (!firstError) firstError = section;
      }
    });
    
    if (!isValid && firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    
    return isValid;
  }

  getProperties() {
    const props = {};
    document.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(input => {
      if (input.value.trim()) {
        const key = input.name.replace(/^properties\[|\]$/g, '');
        props[key] = input.value;
      }
    });
    return props;
  }

  getAddonProperties() {
    const properties = {};
    
    // Get text properties
    document.querySelectorAll('.ab-addons-properties.is-show .js-properties-input').forEach(input => {
      const variantId = input.dataset.variantId;
      const value = input.value.trim();
      const productTitle = input.dataset.productTitle;
      
      if (value && variantId) {
        properties[variantId] = {
          text: value,
          productTitle: productTitle || 'Message'
        };
      }
    });
    
    // Get image properties from AddonState
    if (window.AddonState?.properties) {
      window.AddonState.properties.forEach((propertyData, variantId) => {
        if (propertyData.type === 'image') {
          const section = document.querySelector(`.ab-addons-properties[data-variant-id="${variantId}"]`);
          const productTitle = section?.querySelector('.ab-addons-properties-title')?.textContent || 'Image';
          
          properties[variantId] = {
            text: propertyData.value, 
            productTitle: productTitle
          };
        }
      });
    }    
    
    return properties;
  }


}

customElements.define('ab-product-form', AbProductForm);